import $http from '../services/AxiosInstance';

interface Params {
  page: number;
}

class NocRepository {
  async getlogsMail(params: Params) {
    try {
      let url = `/noc?page=${params.page}`;

      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }

  async getLogFiles(): Promise<Record<string, string[]>> {
    const response = await $http.get('/noc/file-logs');
    return response.data.data;
  }

  async getLogFileContent(type: string, date: string): Promise<string[]> {
    const response = await $http.get(`/noc/file-logs/${type}?date=${date}`);
    return response.data.data;
  }
}

export default NocRepository;
